import './style.scss';
import React, {useEffect, useState} from "react";

import UserProfile from "../../components/userProfile";
import {
  clearAllUserProfileResetPasswordAlerts,
  clearSaveMyProfileErrors, clearSaveUserProfileAlerts, clearSaveUserProfileErrors, clearSendInviteAlerts,
  clearUserFormErrors,
  fetchMyProfile, getManagedUser,
  saveUserProfile, sendInviteEmail, sendUserProfilePasswordReset
} from "../../actions/users";
import {useDispatch, useSelector} from "react-redux";
import EditUserProfile from "./editUserProfile";
import {clearAllForgotPasswordAlerts, sendForgotPassword, sendResetPasswordLink} from "../../actions/session";
import Alert from "../../components/common/alert";
import {MESSAGES} from "../../constants";
import {userCanAccess} from "../../utils/users";
import UserPermissions from "../../components/userPermissions";

export const route = 'user-profile';

const ManageUserProfile = () => {
  const dispatch = useDispatch();

  const managedUser = useSelector((state) => state.users.managedUser);
  const currentUser = useSelector((state) => state.session.currentUser);

  const [profileEdit, setProfileEdit] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const errors = useSelector((state) => state.users.userFormErrors);

  useEffect(() => {
    if (managedUser) {
      const user = {
        'username': managedUser,
        'apiError': 'SUCCESS'
      }

      dispatch(fetchMyProfile(user));
      dispatch(clearSaveUserProfileAlerts());
    } else {
      dispatch(getManagedUser());
    }
  }, [managedUser, dispatch]);

  const userProfile = useSelector((state) => state.users.myProfile);
  const currentUserComposite = useSelector((state) => state.session.currentUserComposite);
  const saveUserProfileSuccess = useSelector((state) => state.users.saveMyProfileApiSuccess);
  const saveUserProfileErrors = useSelector((state) => state.users.saveUserProfileErrors);
  const sendResetPasswordSucceeded = useSelector((state) => state.users.sendUserProfileResetPasswordSuccess);
  const sendResetPasswordError = useSelector((state) => state.users.sendUserProfileResetPasswordError);

  const sessionId = useSelector((state) => state.session.sessionData);

  const onSubmitAction = (profileForm, myProfile) => {
    dispatch(saveUserProfile(profileForm, userProfile));
    setFormSubmitted(true);
  }

  const onDismissAlert = () => {
    dispatch(clearSaveUserProfileErrors());
  }

  const gotoEditAction = () => {
    setProfileEdit(true);
  }

  const sendResetPasswordAction = (userToSend) => {
    dispatch(clearAllUserProfileResetPasswordAlerts());
    dispatch(sendUserProfilePasswordReset(userToSend));
  }

  if (formSubmitted && !errors) {
    setFormSubmitted(false);
    setProfileEdit(false);
  }

  return (!(userProfile) ? <></> :
    <div className='main-content'>
      <div className='user-profile-header'>Manage Users / {userProfile.user.firstName} {userProfile.user.lastName}</div>
      <div className='manage-users-alerts'>
        {(saveUserProfileErrors) && <Alert messageType='error' onDismiss={() => dispatch(clearSaveUserProfileErrors())}>{MESSAGES.USERS.saveUserProfileErrors}</Alert>}
        {(sendResetPasswordError) && <Alert messageType='error' onDismiss={() => dispatch(clearAllUserProfileResetPasswordAlerts())}>{MESSAGES.USERS.sendResetPasswordError}</Alert>}
        {(saveUserProfileSuccess) && <Alert messageType='success' onDismiss={() => dispatch(clearSaveUserProfileAlerts())}>{`${MESSAGES.GENERAL.success} ${userProfile.user.firstName} ${userProfile.user.lastName}${MESSAGES.USERS.saveUserProfileSuccess}`}</Alert>}
        {(sendResetPasswordSucceeded) && <Alert messageType='success' onDismiss={() => dispatch(clearAllUserProfileResetPasswordAlerts())}>{`${MESSAGES.GENERAL.success} ${userProfile.user.firstName} ${userProfile.user.lastName} ${MESSAGES.USERS.sendResetPasswordSuccess}`}</Alert>}
      </div>
      <div className='user-profile-container'>
        <div className='user-info-content'>
          {(userCanAccess(currentUserComposite, 'edit-user') && profileEdit)
            ? <EditUserProfile userProfile={userProfile} errors={errors} onSubmitAction={onSubmitAction} sendResetPasswordAction={sendResetPasswordAction} onCancelAction={() => {dispatch(clearUserFormErrors()); setProfileEdit(false)}}/>
            : <UserProfile profile={userProfile} gotoEditAction={gotoEditAction} sendResetPasswordAction={sendResetPasswordAction}/>
          }
        </div>
      </div>
      <div className='user-permissions-container'>
        <UserPermissions userProfile={userProfile}/>
      </div>
    </div>
  )
}

export default ManageUserProfile;